export default "__VITE_ASSET__Czd7p7Q9__"